"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCpopAbpPromoAmount = exports.getPromotionDetailsFromCatalog = exports.getCustomerTypeFromCartRep = exports.getProductSKU = exports.removeAcpCustomerStatusFromSessionStorage = exports.getAutoPayPromotionAmount = exports.checkoutABPPromo = exports.isFirstNetCustomer = exports.hasMobileDevice = exports.getTaxDetaillsFromOrderPriceInfo = exports.isBBorBBandATTtvInCart = exports.getBroadbandPlanAmount = exports.getCartPanelCollpaseContext = exports.isBBSelfInstall = exports.isACMEOspreyAppleDeviceInCart = exports.isPrepaidMultiMonthPlanSlected = exports.getRewardOfferRefId = exports.getDeviceOfferPromoRefID = exports.isEnableCreditCheckText = exports.isEdspCreditCheck = exports.IsEDSPFlow = exports.CHANNEL_TYPE = exports.getLinkClickBasekUrl = exports.getPlanListFromLOB = exports.getItemsListFromLOB = exports.getItemsListFromCart = exports.getShippingCost = exports.getInsuranceListFromLOB = exports.getPlanListFromCart = exports.getInsuranceListFromCart = exports.isQueryInURL = exports.isExpupgradeViewEnable = exports.getIsGigaInCart = exports.getEnabledeviceLegalMessage = exports.isSMBCustomer = exports.getTrueFeesFlag = exports.getPostpaidflowtype = exports.getTradeInPortInConsented = exports.hboMaxIncludedFree = exports.getBillingPanelHeader = exports.getAttTvDeviceQuantity = exports.lobCartKeys = exports.isAppleDevice = exports.isMobileUserAgent = exports.getEAPDetails = exports.getFinalPrice = exports.getEffectivePricing = exports.displayLineItemPrice = exports.devicePrice = exports.getLineItemPrice = exports.getDeviceDetailsFromLOSG = exports.getProductSkusByDevice = exports.isBYODFlow = exports.getWirelessCharacteristics = exports.getUpgradeLosgId = exports.ischangeRatePlanFlow = exports.getExistingPlanName = exports.DEVICE_TYPE = void 0;
var commonUtils = require("./UtilityFunctions");
var Common = require("./CommonUtilFuntions");
var ReportingService_1 = require("../api/ReportingService");
var localdatastore_1 = require("../config/localdatastore");
var StateProvider_1 = require("../api/StateProvider");
var CheckoutConstants_1 = require("./CheckoutConstants");
var UtilityFunctions_1 = require("./UtilityFunctions");
exports.DEVICE_TYPE = {
    MOBILE: 'SP',
    TABLET: 'T',
    WATCH: 'SD',
};
function getExistingPlanName() {
    var formattedplanDetails = {};
    var payload = commonUtils.getCartResp();
    if ((payload === null || payload === void 0 ? void 0 : payload.wirelessCart) && ischangeRatePlanFlow().isCrpCustomer) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losgData) {
            var _a;
            if ((((_a = losgData.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP')) {
                Object.values(losgData.lineItems).forEach(function (lineItem) {
                    if (lineItem && lineItem.itemType &&
                        lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP') {
                        formattedplanDetails.itemCategory = 'Package';
                        formattedplanDetails.itemHierarchy = 'Account level';
                        formattedplanDetails.itemName = lineItem.displayName;
                        formattedplanDetails.itemQty = 1;
                        formattedplanDetails.itemSku = lineItem.productSKU;
                        formattedplanDetails.itemSocCode = lineItem.billingCode;
                    }
                });
            }
        });
    }
    return formattedplanDetails;
}
exports.getExistingPlanName = getExistingPlanName;
function ischangeRatePlanFlow() {
    var _a, _b, _c, _d;
    var payload = commonUtils.getCartResp();
    var currentDateValue = (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.planStartDate;
    var changeLosgData = {
        crpPlanName: '',
        crpPlanStartdate: currentDateValue,
        crpPrice: 0,
        isCrpCustomer: false,
    };
    Object.values((_d = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _d === void 0 ? void 0 : _d.losgs).forEach(function (losgData) {
        if ((losgData === null || losgData === void 0 ? void 0 : losgData.losgType) === 'CHANGE' && (losgData === null || losgData === void 0 ? void 0 : losgData.parentLosgId) &&
            getUpgradeLosgId() === (losgData === null || losgData === void 0 ? void 0 : losgData.parentLosgId)) {
            changeLosgData.isCrpCustomer = true;
            Object.values(losgData === null || losgData === void 0 ? void 0 : losgData.lineItems).forEach(function (lineItemData) {
                var _a, _b;
                if (((_a = lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'SHAREDDATAFEATURE') {
                    changeLosgData.crpPlanName = lineItemData.displayName;
                    changeLosgData.crpPrice = (_b = lineItemData.price) === null || _b === void 0 ? void 0 : _b.amount;
                }
            });
        }
    });
    return changeLosgData;
}
exports.ischangeRatePlanFlow = ischangeRatePlanFlow;
function getUpgradeLosgId() {
    var _a;
    var payload = UtilityFunctions_1.getCartResp();
    var upLosgId;
    Object.values((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs).forEach(function (losgData) {
        if (losgData.losgType === 'UP') {
            upLosgId = losgData.id;
        }
    });
    return upLosgId;
}
exports.getUpgradeLosgId = getUpgradeLosgId;
function getWirelessCharacteristics(losgId) {
    var _a;
    var wirelessCharacteristics = {
        byodIndicator: false,
        deviceType: '',
        simType: '',
    };
    var cartResponse = commonUtils.getCartResp();
    if (((_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) && losgId) {
        var losgData = cartResponse.wirelessCart.losgs[losgId];
        if (losgData) {
            Object.values(losgData.lineItems).forEach(function (lineItemData) {
                var _a, _b;
                if (((_a = lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.hardGood) === null || _a === void 0 ? void 0 : _a.hardGoodType) === 'DEVICE') {
                    wirelessCharacteristics.byodIndicator = lineItemData.hardGood.byodIndicator;
                    if (lineItemData.hardGood.wirelessHardGoodCharacteristics) {
                        wirelessCharacteristics.deviceType = lineItemData.hardGood
                            .wirelessHardGoodCharacteristics.imei;
                        wirelessCharacteristics.simType = (_b = lineItemData.hardGood
                            .wirelessHardGoodCharacteristics) === null || _b === void 0 ? void 0 : _b._simType;
                    }
                }
            });
        }
    }
    return wirelessCharacteristics;
}
exports.getWirelessCharacteristics = getWirelessCharacteristics;
function isBYODFlow() {
    var _a;
    var response = {
        isBYODFlow: false,
        isMixedFlowWithBYOD: false,
    };
    var isByodDevicePresent = false;
    var isNONBYODDevicePresent = false;
    var cartResponse = commonUtils.getCartResp();
    if ((_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        var losgs = Object.values(cartResponse.wirelessCart.losgs);
        if (losgs) {
            losgs.forEach(function (losg) {
                var items = Object.values(losg.lineItems);
                if (items) {
                    items.forEach(function (item) {
                        var _a, _b;
                        if (((_a = item.hardGood) === null || _a === void 0 ? void 0 : _a.hardGoodType) === 'DEVICE') {
                            if ((_b = item.hardGood) === null || _b === void 0 ? void 0 : _b.byodIndicator) {
                                isByodDevicePresent = true;
                            }
                            else {
                                isNONBYODDevicePresent = true;
                            }
                        }
                    });
                }
            });
        }
    }
    if (isByodDevicePresent && !isNONBYODDevicePresent) {
        response.isBYODFlow = true;
    }
    else if (isByodDevicePresent && isNONBYODDevicePresent) {
        response.isMixedFlowWithBYOD = true;
    }
    return response;
}
exports.isBYODFlow = isBYODFlow;
function getProductSkusByDevice() {
    var _a, _b;
    var billingCode = null;
    var lineItems = (_b = (_a = commonUtils.getCartResp()) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs;
    /* tslint:disable*/
    for (var items in lineItems) {
        var logs = lineItems[items];
        for (var data in logs.lineItems) {
            var objItems = logs.lineItems[data];
            for (var datas in objItems) {
                var deviceType = objItems;
                if (deviceType.itemType === 'device') {
                    billingCode = deviceType.billingCode;
                }
            }
        }
    }
    return billingCode;
}
exports.getProductSkusByDevice = getProductSkusByDevice;
function getDeviceDetailsFromLOSG(losgID) {
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        var wirelessLosgs = payload.wirelessCart.losgs[losgID];
        var allItemsList = (wirelessLosgs && wirelessLosgs.lineItems && Object.values(wirelessLosgs.lineItems));
        return allItemsList && allItemsList.filter(function (values) { return (values.itemType === 'device'); })[0];
    }
    return null;
}
exports.getDeviceDetailsFromLOSG = getDeviceDetailsFromLOSG;
function getLineItemPrice(losgID) {
    var lineItem = getDeviceDetailsFromLOSG(losgID);
    if (lineItem) {
        var getPromoDetails = getEffectivePricing(lineItem);
        if (displayLineItemPrice(lineItem)) {
            return devicePrice(lineItem);
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && getPromoDetails.effectiveDevicePrice === 0) {
            return 0.00;
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && getPromoDetails.effectiveDevicePrice > 0) {
            return getPromoDetails.effectiveDevicePrice;
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && getPromoDetails.effectiveDevicePrice === 0) {
            return 0.00;
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && (getPromoDetails.effectiveDevicePrice > 0 ||
                getPromoDetails.effectiveDevicePrice < 0)) {
            return Math.abs(getPromoDetails.
                effectiveDevicePrice);
        }
    }
    return 0.00;
}
exports.getLineItemPrice = getLineItemPrice;
function devicePrice(lineItem) {
    var finalAmount = getFinalPrice(lineItem.price);
    if (lineItem.contractDetails && (lineItem.contractDetails.contractType === 'LEASE' ||
        lineItem.contractDetails.contractType === 'INSTALLMENT')) {
        finalAmount = lineItem.contractDetails.installmentAmount;
    }
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'ACCESSORY' && lineItem.price) {
        finalAmount = lineItem.price.total;
    }
    return finalAmount;
}
exports.devicePrice = devicePrice;
function displayLineItemPrice(lineItem) {
    var displayItemPrice = !!!(lineItem.price);
    var getPromoDetails = getEffectivePricing(lineItem);
    if (getPromoDetails && getPromoDetails.isPromoLineItem) {
        displayItemPrice = false;
    }
    return displayItemPrice;
}
exports.displayLineItemPrice = displayLineItemPrice;
function getEffectivePricing(lineItem) {
    var bogoPricingInfo = {
        effectiveDevicePrice: 0,
        isPromoLineItem: false,
    };
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE' &&
        lineItem.promotionReferences && lineItem.promotionReferences.length > 0 &&
        lineItem.contractDetails && lineItem.contractDetails.contractType &&
        (lineItem.contractDetails.contractType.toUpperCase() === 'LEASE' ||
            lineItem.contractDetails.contractType.toUpperCase() === 'INSTALLMENT') &&
        lineItem.contractDetails._effectiveLeaseAmount !== undefined &&
        lineItem.contractDetails._effectiveLeaseAmount !== lineItem.contractDetails.installmentAmount) {
        bogoPricingInfo.isPromoLineItem = true;
        bogoPricingInfo.effectiveDevicePrice = lineItem.contractDetails._effectiveLeaseAmount;
    }
    return bogoPricingInfo;
}
exports.getEffectivePricing = getEffectivePricing;
function getFinalPrice(price) {
    var finalPrice = 0.00;
    if (price && price.baseAmount && price.amount) {
        if (price.baseAmount && price.baseAmount.toString() !== '0.00') {
            finalPrice = price.baseAmount;
        }
        else {
            finalPrice = price.amount;
        }
    }
    return finalPrice;
}
exports.getFinalPrice = getFinalPrice;
function getEAPDetails() {
    var eapDetails = {
        activatedDeviceMake: '',
        activatedDeviceModel: '',
        deviceSubType: '',
        eapFlowType: '',
        isEAPFlow: false,
        simType: '',
    };
    var orderSubType = commonUtils.getOrderSubType();
    if (orderSubType) {
        var respOrderSubType = orderSubType.toUpperCase();
        switch (respOrderSubType) {
            case 'NEW_WIRELESS_ACTIVATION':
            case 'NEW_WIRELESS_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'NEW_EAP';
                eapDetails.isEAPFlow = true;
                break;
            case 'NEW_WIRELESS_ON_ACTIVATION':
            case 'NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'NEW_EAP_ON';
                eapDetails.isEAPFlow = true;
                break;
            case 'AAL_WIRELESS_ACTIVATION':
            case 'AAL_WIRELESS_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'AAL_EAP';
                eapDetails.isEAPFlow = true;
                break;
            case 'AAL_WIRELESS_ON_ACTIVATION':
            case 'AAL_WIRELESS_ON_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'AAL_EAP_ON';
                eapDetails.isEAPFlow = true;
                break;
            default:
                eapDetails.eapFlowType = '';
                eapDetails.isEAPFlow = false;
                break;
        }
    }
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        var wirelessLosgs_1 = payload.wirelessCart.losgs;
        if (wirelessLosgs_1) {
            Object.keys(wirelessLosgs_1).forEach(function (losg) {
                var lineItems = wirelessLosgs_1[losg].lineItems;
                if (lineItems) {
                    Object.keys(lineItems).forEach(function (key) {
                        var _a, _b, _c, _d;
                        if (lineItems[key].itemType && lineItems[key].itemType === 'device'
                            && Common.isKeyExist(lineItems[key], 'hardGood.make')) {
                            eapDetails.activatedDeviceMake = lineItems[key].hardGood.make;
                            eapDetails.activatedDeviceModel = lineItems[key].hardGood.model;
                            if (((_a = lineItems[key]._itemExtraAttributes) === null || _a === void 0 ? void 0 : _a.simType) && eapDetails.isEAPFlow) {
                                eapDetails.simType = lineItems[key]._itemExtraAttributes.simType;
                            }
                            eapDetails.deviceSubType = (_d = (_c = (_b = lineItems[key]) === null || _b === void 0 ? void 0 : _b.hardGood) === null || _c === void 0 ? void 0 : _c.wirelessHardGoodCharacteristics) === null || _d === void 0 ? void 0 : _d._deviceSubType;
                        }
                    });
                }
            });
        }
    }
    return eapDetails;
}
exports.getEAPDetails = getEAPDetails;
function isMobileUserAgent() {
    if (navigator && navigator.userAgent) {
        return /Android|webOS|iPhone|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobileUserAgent = isMobileUserAgent;
function isAppleDevice() {
    var ua = navigator.userAgent;
    return (/iPad|iPhone|iPod/.test(ua))
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
exports.isAppleDevice = isAppleDevice;
exports.lobCartKeys = new Map([
    ['DTVS', { metadata: 'dtvsMetadata', cartKey: 'dtvsCart' }],
    ['IPTV', { metadata: 'iptvMetadata', cartKey: 'iptvCart' }],
    ['BROADBAND', { metadata: 'broadbandMetadata', cartKey: 'broadbandCart' }],
    ['DTVNOW', { metadata: 'dtvMetadata', cartKey: 'dtvnowCart' }],
    ['WIRELESS', { metadata: 'wirelessMetadata', cartKey: 'wirelessCart' }],
]);
function getAttTvDeviceQuantity() {
    var quantity = 0;
    var payload = commonUtils.getCartResp();
    if (payload
        && payload.dtvnowCart && payload.dtvnowCart.losgs) {
        var attTvLosgs = payload.dtvnowCart.losgs;
        Object.values(attTvLosgs).filter(function (losgItem) {
            return Object.values(losgItem.lineItems).filter(function (lineItem) {
                if (lineItem.itemType === 'EQUIPMENT') {
                    quantity = quantity + lineItem.quantity;
                }
                return lineItem.itemType === 'EQUIPMENT';
            }).length > 0;
        });
    }
    return quantity;
}
exports.getAttTvDeviceQuantity = getAttTvDeviceQuantity;
function getBillingPanelHeader(cmsData) {
    var dtvnbbPresent = commonUtils.IsDTVNOWInCart() && commonUtils.IsBroadbandInCart();
    var currentFlowType = commonUtils.getCurrentFlowType();
    var title = cmsData.sectionTitleLabel;
    if (currentFlowType === CheckoutConstants_1.FlowType.WIRELESS_PREPAID) {
        title = cmsData.sectionAutopayTitleLabel;
    }
    else if (dtvnbbPresent) {
        title = cmsData.titleLabelInternet;
    }
    else if (currentFlowType === CheckoutConstants_1.FlowType.NEW_BROADBAND_NEW_HBOMAX && commonUtils.IsHBOMaxCharged()) {
        title = cmsData.titleLabelInternet;
    }
    else if ((currentFlowType === CheckoutConstants_1.FlowType.NEW_WIRELESS_NEW_HBOMAX
        || currentFlowType === CheckoutConstants_1.FlowType.NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX)
        && commonUtils.IsHBOMaxCharged()) {
        title = cmsData.titleLabelWireless;
    }
    return title;
}
exports.getBillingPanelHeader = getBillingPanelHeader;
function hboMaxIncludedFree(hboMaxIncluded) {
    if (hboMaxIncluded && hboMaxIncluded.toUpperCase() === 'FREE') {
        return true;
    }
    else {
        return false;
    }
}
exports.hboMaxIncludedFree = hboMaxIncludedFree;
function getTradeInPortInConsented() {
    var portInIndicators = {
        hylatradeInCustomerConsented: false,
        portInCustomerConsented: false,
    };
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].
                    _hylaTradeInCustomerConsented !== undefined) {
                portInIndicators.hylatradeInCustomerConsented =
                    payload.wirelessCart.losgs[key].
                        _hylaTradeInCustomerConsented;
            }
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].
                    _portinCustomerConsented !== undefined) {
                portInIndicators.portInCustomerConsented =
                    payload.wirelessCart.losgs[key].
                        _portinCustomerConsented;
            }
        });
    }
    return portInIndicators;
}
exports.getTradeInPortInConsented = getTradeInPortInConsented;
function getPostpaidflowtype() {
    var orderSubType = commonUtils.getOrderSubType();
    var flowtype = '';
    if (orderSubType) {
        if (orderSubType === 'AAL_WIRELESS') {
            flowtype = 'AL';
        }
        if (orderSubType === 'UPGRADE_WIRELESS' || orderSubType === 'UP_AL_WIRELESS') {
            flowtype = 'UP';
        }
    }
    return flowtype;
}
exports.getPostpaidflowtype = getPostpaidflowtype;
function getTrueFeesFlag() {
    var payload = commonUtils.getCartResp();
    if (payload && payload.enableTrueFees && commonUtils.IsDTVSInCart()) {
        return true;
    }
    return false;
}
exports.getTrueFeesFlag = getTrueFeesFlag;
function isSMBCustomer() {
    var payload = commonUtils.getCartResp();
    var isWirelessSMBCustomer = payload && payload.wirelessCart && payload.wirelessCart._orderExtraAttributes
        && payload.wirelessCart._orderExtraAttributes._isSMBCustomer
        && payload.wirelessCart._orderExtraAttributes._isSMBCustomer === 'true';
    var isBroadbandSMBCustomer = payload && payload.broadbandCart && payload.broadbandCart.customerType
        && payload.broadbandCart.customerType.toUpperCase() === 'SMB';
    if (payload && payload.b2bDetail &&
        payload.b2bDetail._enterpriseType &&
        payload.b2bDetail._enterpriseType === 'CRU') {
        return true;
    }
    else if (isWirelessSMBCustomer || isBroadbandSMBCustomer) {
        return true;
    }
    return false;
}
exports.isSMBCustomer = isSMBCustomer;
function getEnabledeviceLegalMessage() {
    var payload = commonUtils.getCartResp();
    if (!IsEDSPFlow() && payload
        && payload.enabledeviceLegalMessage) {
        return true;
    }
    return false;
}
exports.getEnabledeviceLegalMessage = getEnabledeviceLegalMessage;
function getIsGigaInCart() {
    var payload = commonUtils.getCartResp();
    if (payload &&
        payload.broadbandCart && payload.broadbandCart.isGigaInCart) {
        return payload.broadbandCart.isGigaInCart;
    }
    else {
        return false;
    }
}
exports.getIsGigaInCart = getIsGigaInCart;
function isExpupgradeViewEnable() {
    var payload = commonUtils.getCartResp();
    if (payload &&
        payload.enableExpupgradeView) {
        return payload.enableExpupgradeView;
    }
    else {
        return false;
    }
}
exports.isExpupgradeViewEnable = isExpupgradeViewEnable;
function isQueryInURL(url, queryString) {
    var queryParam = url.split('?')[1];
    if (queryParam) {
        var parmaArry = queryParam.split('&');
        if (parmaArry.includes(queryString)) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
exports.isQueryInURL = isQueryInURL;
function getInsuranceListFromCart() {
    var finalAllItems = '';
    var orderCartPayload = commonUtils.getCartResp();
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.dtvnowCart
        && orderCartPayload.dtvnowCart.losgs);
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.wirelessCart
        && orderCartPayload.wirelessCart.losgs);
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.dtvsCart
        && orderCartPayload.dtvsCart.losgs);
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.iptvCart
        && orderCartPayload.iptvCart.losgs);
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.broadbandCart
        && orderCartPayload.broadbandCart.losgs);
    finalAllItems = finalAllItems + getInsuranceListFromLOB(orderCartPayload
        && orderCartPayload.accessoryCart
        && orderCartPayload.accessoryCart.losgs);
    return finalAllItems;
}
exports.getInsuranceListFromCart = getInsuranceListFromCart;
function getPlanListFromCart() {
    var finalAllItems = '';
    var orderCartPayload = commonUtils.getCartResp();
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.dtvnowCart
        && orderCartPayload.dtvnowCart.losgs);
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.wirelessCart
        && orderCartPayload.wirelessCart.losgs);
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.dtvsCart
        && orderCartPayload.dtvsCart.losgs);
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.iptvCart
        && orderCartPayload.iptvCart.losgs);
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.broadbandCart
        && orderCartPayload.broadbandCart.losgs);
    finalAllItems = finalAllItems + getPlanListFromLOB(orderCartPayload
        && orderCartPayload.accessoryCart
        && orderCartPayload.accessoryCart.losgs);
    return finalAllItems;
}
exports.getPlanListFromCart = getPlanListFromCart;
function getInsuranceListFromLOB(losgs) {
    var finalList = '';
    var isItemsAvailable = false;
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues.forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    isItemsAvailable = true;
                    if (item && item.productSubType && item.itemType === 'feature'
                        && (item.productSubType.indexOf('Insurance') >= -1)) {
                        finalList = finalList + (finalList !== '' ? ',' : '') + 'MI';
                    }
                });
            }
        });
    }
    else {
        return '';
    }
    if (isItemsAvailable && finalList === '') {
        finalList = 'NONE';
    }
    return finalList;
}
exports.getInsuranceListFromLOB = getInsuranceListFromLOB;
function getShippingCost() {
    var payload = commonUtils.getCartResp();
    if (payload
        && payload.shippingDetails
        && payload.shippingDetails.shippingPrice) {
        return Number(payload.shippingDetails.shippingPrice);
    }
    return 0;
}
exports.getShippingCost = getShippingCost;
function getItemsListFromCart() {
    var finalAllItems = '';
    var orderCartPayload = commonUtils.getCartResp();
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.dtvnowCart
        && orderCartPayload.dtvnowCart.losgs);
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.wirelessCart
        && orderCartPayload.wirelessCart.losgs);
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.dtvsCart
        && orderCartPayload.dtvsCart.losgs);
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.iptvCart
        && orderCartPayload.iptvCart.losgs);
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.broadbandCart
        && orderCartPayload.broadbandCart.losgs);
    finalAllItems = finalAllItems + getItemsListFromLOB(orderCartPayload
        && orderCartPayload.accessoryCart
        && orderCartPayload.accessoryCart.losgs);
    return finalAllItems;
}
exports.getItemsListFromCart = getItemsListFromCart;
function getItemsListFromLOB(losgs) {
    var finalSKUsList = '';
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues.forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    if (item && item.hardGood && (item.hardGood.hardGoodType === 'DEVICE')) {
                        finalSKUsList = finalSKUsList + (finalSKUsList !== '' ? ',' : '') + item.productSKU;
                    }
                });
            }
        });
    }
    return finalSKUsList;
}
exports.getItemsListFromLOB = getItemsListFromLOB;
function getPlanListFromLOB(losgs) {
    var finalPlansList = '';
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues.forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    if (item && item.productType && (item.productType === 'PLAN')) {
                        finalPlansList = finalPlansList + (finalPlansList !== '' ? ',' : '') + item.billingCode;
                    }
                });
            }
        });
    }
    return finalPlansList;
}
exports.getPlanListFromLOB = getPlanListFromLOB;
function getLinkClickBasekUrl() {
    var expressView = isExpupgradeViewEnable();
    if (expressView) {
        return ReportingService_1.PageUrls.CARTVIEW_PAGE;
    }
    else {
        return ReportingService_1.PageUrls.CART_PAGE;
    }
}
exports.getLinkClickBasekUrl = getLinkClickBasekUrl;
var CHANNEL_TYPE;
(function (CHANNEL_TYPE) {
    CHANNEL_TYPE["CHANNEL_NATIVE"] = "native";
    CHANNEL_TYPE["CHANNEL_EMAIL"] = "email";
})(CHANNEL_TYPE = exports.CHANNEL_TYPE || (exports.CHANNEL_TYPE = {}));
function IsEDSPFlow() {
    var payload = commonUtils.getCartResp();
    return !!(payload
        && payload.dtvnowCart &&
        payload.dtvnowCart.contractType === 'EDSP');
}
exports.IsEDSPFlow = IsEDSPFlow;
function isEdspCreditCheck() {
    var payload = commonUtils.getCartResp();
    return !!(IsEDSPFlow() && payload &&
        payload.enableEdspCreditCheck);
}
exports.isEdspCreditCheck = isEdspCreditCheck;
function isEnableCreditCheckText() {
    var payload = commonUtils.getCartResp();
    return !!(payload && payload.enableCreditCheckText);
}
exports.isEnableCreditCheckText = isEnableCreditCheckText;
function getDeviceOfferPromoRefID() {
    var payload = commonUtils.getCartResp();
    var promotionCode = '';
    if (payload && payload.wirelessCart
        && payload.wirelessCart.promotions
        && payload.wirelessCart.promotions.length) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            if (promo.promotionCategory && promo.promotionCategory.toUpperCase() === 'STACKABLE_STANDALONE_PROMO') {
                promotionCode = promo.id;
            }
        });
    }
    return promotionCode;
}
exports.getDeviceOfferPromoRefID = getDeviceOfferPromoRefID;
function getRewardOfferRefId() {
    var payload = commonUtils.getCartResp();
    var rewardPromo = {
        promotionAmount: 0,
        promotionCode: '',
    };
    if (payload && payload.wirelessCart
        && payload.wirelessCart.promotions
        && payload.wirelessCart.promotions.length) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            if (promo._intent && promo._intent.toUpperCase() === 'PRIVATE') {
                rewardPromo.promotionCode = promo.id;
                rewardPromo.promotionAmount = promo.amount;
            }
        });
    }
    return rewardPromo;
}
exports.getRewardOfferRefId = getRewardOfferRefId;
exports.isPrepaidMultiMonthPlanSlected = function () {
    var isMultiMonthPlanExists = false;
    var payload = commonUtils.getCartResp();
    if (payload && payload.wirelessCart && !!payload.wirelessCart.losgs) {
        var wirrelessLosgs = payload.wirelessCart.losgs;
        Object.values(wirrelessLosgs).map(function (losgItem) {
            Object.values(losgItem.lineItems).some(function (lineItem) {
                if (lineItem.planType && lineItem.planType.toUpperCase() === 'NONMONTHLY') {
                    isMultiMonthPlanExists = true;
                    return isMultiMonthPlanExists;
                }
            });
        });
    }
    return isMultiMonthPlanExists;
};
function isACMEOspreyAppleDeviceInCart() {
    var _a;
    var devicesInCart = {
        appleInCart: false,
        ospreyInCart: false,
        singleBoxShipping: false,
    };
    var payload = commonUtils.getCartResp();
    if (commonUtils.IsDTVNOWInCart() && commonUtils.IsBroadbandInCart() && ((_a = payload === null || payload === void 0 ? void 0 : payload.dtvnowCart) === null || _a === void 0 ? void 0 : _a.losgs)) {
        var singleBoxShipping = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'singleBox');
        if (singleBoxShipping) {
            devicesInCart.singleBoxShipping = singleBoxShipping.singleBox;
        }
        Object.values(payload.dtvnowCart.losgs).forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    if (item && item.hardGood && (item.hardGood.hardGoodType === 'DEVICE')) {
                        if (item.hardGood.make && item.hardGood.make.toLowerCase() === 'apple') {
                            devicesInCart.appleInCart = true;
                        }
                        else if (item.hardGood.make && item.hardGood.make.toLowerCase() === 'atttv') {
                            devicesInCart.ospreyInCart = true;
                        }
                    }
                });
            }
        });
    }
    return devicesInCart;
}
exports.isACMEOspreyAppleDeviceInCart = isACMEOspreyAppleDeviceInCart;
function isBBSelfInstall() {
    var _a, _b, _c;
    var selfInstall = false;
    var payload = commonUtils.getCartResp();
    if ((_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.broadbandMetadata) === null || _c === void 0 ? void 0 : _c.selfInstall) {
        selfInstall = true;
    }
    return selfInstall;
}
exports.isBBSelfInstall = isBBSelfInstall;
function getCartPanelCollpaseContext() {
    var cartPanelCollapseFlags = {
        collapseOnInitial: false,
        displayCollapseOption: false,
    };
    if (commonUtils.IsWirelessInCart()) {
        cartPanelCollapseFlags.displayCollapseOption = false;
        cartPanelCollapseFlags.collapseOnInitial = false;
    }
    return cartPanelCollapseFlags;
}
exports.getCartPanelCollpaseContext = getCartPanelCollpaseContext;
exports.getBroadbandPlanAmount = function () {
    var bbPlanAmount = 0;
    var payload = commonUtils.getCartResp();
    if (payload && payload.broadbandCart && !!payload.broadbandCart.losgs) {
        var broadbandLosgs = payload.broadbandCart.losgs;
        Object.values(broadbandLosgs).map(function (losgItem) {
            Object.values(losgItem.lineItems).some(function (lineItem) {
                if (lineItem.productType && lineItem.productType.toUpperCase() === 'PLAN'
                    && lineItem.price && lineItem.price.amount) {
                    bbPlanAmount = lineItem.price.amount;
                }
            });
        });
    }
    return bbPlanAmount;
};
exports.isBBorBBandATTtvInCart = function () {
    return (CheckoutConstants_1.FlowType.NEW_BROADBAND + "|" + CheckoutConstants_1.FlowType.NEW_BROADBAND_NEW_HBOMAX + "|\n        " + CheckoutConstants_1.FlowType.NEW_DTVNOW_NEW_BROADBAND + "|" + CheckoutConstants_1.FlowType.NEW_DTVNOW_NEW_BROADBAND_NEW_HBOMAX).indexOf(commonUtils.getCurrentFlowType()) > -1;
};
function getTaxDetaillsFromOrderPriceInfo() {
    var _a, _b;
    var payload = commonUtils.getCartResp();
    if (payload === null || payload === void 0 ? void 0 : payload.orderPriceInfo) {
        return {
            prepaidTaxAmount: (_a = payload.orderPriceInfo) === null || _a === void 0 ? void 0 : _a.prepaidTaxAmount,
            totalTax: (_b = payload.orderPriceInfo) === null || _b === void 0 ? void 0 : _b.tax,
        };
    }
    return null;
}
exports.getTaxDetaillsFromOrderPriceInfo = getTaxDetaillsFromOrderPriceInfo;
function hasMobileDevice(data) {
    var hasMobile = false;
    var keys = Object.keys(data);
    keys && keys.length && keys.forEach(function (i) { return !hasMobile ? hasMobile = data[i].deviceCategory === exports.DEVICE_TYPE.MOBILE : ''; });
    return hasMobile;
}
exports.hasMobileDevice = hasMobileDevice;
function isFirstNetCustomer() {
    var _a, _b;
    var firstNet = commonUtils.isFirstNetFlow();
    var firstNetObj = JSON.parse(sessionStorage.getItem('wlsPostpaid'));
    if (firstNetObj) {
        if (firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponseAl) {
            firstNet = firstNetObj && (firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponseAl) && ((_a = firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponseAl) === null || _a === void 0 ? void 0 : _a.isFirstNet);
        }
        else if (firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponse) {
            firstNet = firstNetObj && (firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponse) && ((_b = firstNetObj === null || firstNetObj === void 0 ? void 0 : firstNetObj.wirelessResponse) === null || _b === void 0 ? void 0 : _b.isFirstNet);
        }
    }
    return firstNet;
}
exports.isFirstNetCustomer = isFirstNetCustomer;
function checkoutABPPromo(cart) {
    var cartPromoList = cart === null || cart === void 0 ? void 0 : cart.promotions;
    for (var key in cartPromoList) {
        if (cartPromoList[key] && cartPromoList[key].discountCategory === 'ABPDiscount') {
            return true;
        }
    }
    return false;
}
exports.checkoutABPPromo = checkoutABPPromo;
function getAutoPayPromotionAmount(promotions) {
    var promotionValue = 0;
    if (promotions && promotions.length > 0) {
        promotions.forEach(function (promo) {
            var _a;
            if ((promo.promotionCategory === 'ABPDiscount' ||
                ((_a = promo === null || promo === void 0 ? void 0 : promo.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'abpdiscount') && promo.amount) {
                promotionValue = promo.amount;
            }
        });
    }
    return promotionValue;
}
exports.getAutoPayPromotionAmount = getAutoPayPromotionAmount;
function removeAcpCustomerStatusFromSessionStorage() {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem('acpCustomerStatus');
}
exports.removeAcpCustomerStatusFromSessionStorage = removeAcpCustomerStatusFromSessionStorage;
function getProductSKU(id) {
    var _a, _b;
    var productSKU = '';
    var cartResponse = commonUtils.getCartResp();
    if (((_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) && id) {
        var losgData = (_b = cartResponse.wirelessCart.losgs) === null || _b === void 0 ? void 0 : _b[id];
        if (losgData) {
            Object.values(losgData === null || losgData === void 0 ? void 0 : losgData.lineItems).forEach(function (lineItemData) {
                var _a;
                if (((_a = lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
                    productSKU = (lineItemData === null || lineItemData === void 0 ? void 0 : lineItemData.productSKU) || "";
                }
            });
        }
    }
    return productSKU;
}
exports.getProductSKU = getProductSKU;
exports.getCustomerTypeFromCartRep = function () {
    var _a, _b, _c, _d;
    var payload = commonUtils.getCartResp();
    var _customerType = 'CONSUMER';
    if (payload && (payload === null || payload === void 0 ? void 0 : payload.b2bDetail)) {
        var _enterpriseType = (_b = (_a = payload.b2bDetail) === null || _a === void 0 ? void 0 : _a._enterpriseType) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        if (_enterpriseType === CheckoutConstants_1.CustomerTypes.IRU) {
            _customerType = 'IRU';
        }
        else if (_enterpriseType === CheckoutConstants_1.CustomerTypes.SMB) {
            _customerType = 'CRU';
        }
        else {
            _customerType = 'CONSUMER';
        }
    }
    if (((_d = (_c = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _c === void 0 ? void 0 : _c._orderExtraAttributes) === null || _d === void 0 ? void 0 : _d._isSMBCustomer) === "true") {
        _customerType = 'CRU';
    }
    return _customerType;
};
exports.getPromotionDetailsFromCatalog = function () {
    var _a, _b, _c;
    var abpPromotion = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace("CART"), "abpPromo");
    var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace("CART"), "cartResponse");
    var removeDeplicateTenderTypes = function (tenderTypes) {
        var uniqueSet = new Set(tenderTypes);
        var arrayWithoutDuplicates = Array.from(uniqueSet);
        return arrayWithoutDuplicates;
    };
    var processPromotionOffers = function (promotionsOffers, _abpInfoList) {
        promotionsOffers === null || promotionsOffers === void 0 ? void 0 : promotionsOffers.forEach(function (promo) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            var amount = ((_c = (_b = (_a = promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.name === 'amount'; })) === null || _b === void 0 ? void 0 : _b.map(function (ele) { return ele.value; })) === null || _c === void 0 ? void 0 : _c[0]) || (promo === null || promo === void 0 ? void 0 : promo.amount);
            var tenderType = ((_f = (_e = (_d = promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item.name === 'tenderTypes'; })) === null || _e === void 0 ? void 0 : _e.map(function (ele) { return ele.value; })) === null || _f === void 0 ? void 0 : _f[0]) || Array.isArray(promo === null || promo === void 0 ? void 0 : promo.tenderTypes) ? (_g = promo === null || promo === void 0 ? void 0 : promo.tenderTypes) === null || _g === void 0 ? void 0 : _g.join() : (promo === null || promo === void 0 ? void 0 : promo.tenderTypes) || '';
            var autoPayEbillEnrollmentType = ((_k = (_j = (_h = promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics) === null || _h === void 0 ? void 0 : _h.filter(function (item) { return item.name === 'autoPayEbillEnrollmentType'; })) === null || _j === void 0 ? void 0 : _j.map(function (ele) { return ele.value; })) === null || _k === void 0 ? void 0 : _k[0]) || (promo === null || promo === void 0 ? void 0 : promo.autoPayEbillEnrollmentType);
            var providerType = '';
            var promotionCode = ((_o = (_m = (_l = promo === null || promo === void 0 ? void 0 : promo.promotionCharacteristics) === null || _l === void 0 ? void 0 : _l.filter(function (item) { return item.name === 'promotionCode'; })) === null || _m === void 0 ? void 0 : _m.map(function (ele) { return ele.value; })) === null || _o === void 0 ? void 0 : _o[0]) || (promo === null || promo === void 0 ? void 0 : promo.promotionCode);
            var abpTypes = {
                amount: amount,
                tenderType: tenderType,
                autoPayEbillEnrollmentType: autoPayEbillEnrollmentType,
                providerType: providerType,
                promotionCode: promotionCode
            };
            if ((abpTypes === null || abpTypes === void 0 ? void 0 : abpTypes.amount) && (abpTypes === null || abpTypes === void 0 ? void 0 : abpTypes.tenderType) && promotionCode && promotionCode !== 'ABPAIAB') {
                var _tenderTypes = removeDeplicateTenderTypes(abpTypes.tenderType.toLowerCase().split(','));
                var _amount = Number(abpTypes.amount);
                if ((_tenderTypes.includes('debitcard') || _tenderTypes.includes('ach')) && _amount > 5) {
                    var index = _tenderTypes.indexOf('creditcard');
                    if (index !== -1) {
                        _tenderTypes.splice(index, 1);
                    }
                    abpTypes.tenderType = String(_tenderTypes);
                    _abpInfoList.push(abpTypes);
                }
                else if (_tenderTypes.includes('creditcard') && _amount > 0 && _amount <= 5) {
                    abpTypes.tenderType = 'creditcard';
                    _abpInfoList.push(abpTypes);
                }
            }
        });
    };
    var _abpInfoList = [];
    if (abpPromotion && ((_a = abpPromotion.promotionsOffers) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        processPromotionOffers(abpPromotion.promotionsOffers, _abpInfoList);
    }
    else if (((_c = (_b = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.payload) === null || _b === void 0 ? void 0 : _b.abpPromotions) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        processPromotionOffers(cartResponse.payload.abpPromotions, _abpInfoList);
    }
    return _abpInfoList.length > 1 ? _abpInfoList : [];
};
// tslint:disable-next-line: no-any
exports.getCpopAbpPromoAmount = function (abpCpopResp, defaultAount) {
    var _abpPromoAmount = {
        default: 10,
        creditcard: 5
    };
    if (abpCpopResp) {
        abpCpopResp === null || abpCpopResp === void 0 ? void 0 : abpCpopResp.forEach(function (item) {
            if ((item === null || item === void 0 ? void 0 : item.amount) && (item === null || item === void 0 ? void 0 : item.tenderType) && (item === null || item === void 0 ? void 0 : item.tenderType.toLowerCase().includes('creditcard'))) {
                _abpPromoAmount.creditcard = item.amount || 5;
            }
            else if ((item === null || item === void 0 ? void 0 : item.amount) && (item === null || item === void 0 ? void 0 : item.tenderType) && ((item === null || item === void 0 ? void 0 : item.tenderType.toLowerCase().includes('debitcard')) || (item === null || item === void 0 ? void 0 : item.tenderType.toLowerCase().includes('ach')))) {
                _abpPromoAmount.default = item.amount || 10;
            }
        });
    }
    return _abpPromoAmount;
};
//# sourceMappingURL=CartUtilFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/CartUtilFunctions.js
// module id = 225
// module chunks = 8